<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Cryptogram-Generator-Root',
};
</script>
